import { Component, OnInit } from '@angular/core';
import { IInsightSubComponents } from 'app/modules/shared/interfaces/module-card-info';

@Component({
    selector: 'app-incentives-insights',
    templateUrl: './incentives-insights.component.html',
    styleUrls: ['./incentives-insights.component.scss'],
})
export class IncentivesInsightsComponent implements OnInit {
    pageSubInsights: IInsightSubComponents[];

    constructor() {}

    ngOnInit() {
        this.setPageInsightCardDetails();
    }

    setPageInsightCardDetails() {
        this.pageSubInsights = [
            {
                moduleRef: 'insight1',
                module: 'incentives',
                insightTitle: 'Insight Option 1',
                insightImgSource: 'insights_graph',
                insightLink: 'incentives/insights/option',
                insightDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            },
        ];
    }
}
